module.exports = __webpack_public_path__ + "static/img/logo_all.22d5dffe.png";